import { storage } from "../firebaseConfig";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

export async function uploadToStorage(file, path) {
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type });
  const url = await getDownloadURL(r);
  return { url, path };
}

export async function deleteFromStorage(path) {
  if (!path) return;
  try {
    const r = ref(storage, path);
    await deleteObject(r);
  } catch {
    // ignore (fichier déjà supprimé)
  }
}
